import { createSelector } from 'reselect'
import { getSelectedDisplayProductCode } from '../product-selection/selectors'
import _ from 'lodash'

export const getSelectedDisplayProduct = (state) => state.selectedDisplayProduct

export const hasProductSelected = createSelector(
  getSelectedDisplayProductCode,
  (productCode) => !_.isEmpty(productCode)
)
